// DO NOT USE THIS COMPONENT without checking in with the growth monetization core team

import { useCallback, useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import { Button } from 'foundations-components/transitional/components/Button';
import { track } from './_core/common/eventTracking/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RequestAccessModalWrapper = ({
  buttonBlock,
  buttonSize,
  buttonUse,
  buttonSeleniumId,
  buttonTestId,
  OpenModalButtonLabel,
  floatingAlertStore,
  ModalBody,
  ModalTitle,
  modalUse = 'default',
  modalWidth = 480,
  onClickOpenModal = () => {},
  requestAccessPromise,
  SubmitRequestButtonLabel,
  usageTrackingProperties
}) => {
  const [showModal, setShowModal] = useState(false);
  const displayAndTrackViewOfRequestAccessModal = useCallback(() => {
    setShowModal(true);
    onClickOpenModal();
    track('viewUpgradeAdminPrompt', usageTrackingProperties);
  }, [onClickOpenModal, usageTrackingProperties]);
  const handleSendRequest = useCallback(() => {
    requestAccessPromise().then(() => {
      setShowModal(false);
      floatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestAccessModalWrapper.onSuccessAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestAccessModalWrapper.onSuccessAlert.title"
        }),
        type: 'success'
      });
    }).catch(__error => {
      floatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestAccessModalWrapper.onFailureAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.requestAccessModalWrapper.onFailureAlert.title"
        }),
        type: 'danger'
      });
    });
  }, [floatingAlertStore, requestAccessPromise]);
  useEffect(() => {
    console.warn('RequestAccessModalWrapper: DO NOT USE THIS COMPONENT without checking in with the growth monetization core team');
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      block: buttonBlock,
      "data-selenium-id": buttonSeleniumId,
      "data-test-id": buttonTestId,
      onClick: displayAndTrackViewOfRequestAccessModal,
      size: buttonSize,
      use: buttonUse,
      children: OpenModalButtonLabel
    }), showModal && /*#__PURE__*/_jsxs(UIModal, {
      use: modalUse,
      width: modalWidth,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          "data-test-id": "admin-modal-close-button",
          onClick: () => {
            setShowModal(false);
          }
        }), /*#__PURE__*/_jsx(H2, {
          children: ModalTitle
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx("p", {
          className: "p-right-4",
          children: ModalBody
        })
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "admin-modal-submit-button",
          use: buttonUse,
          onClick: handleSendRequest,
          children: SubmitRequestButtonLabel
        })
      })]
    })]
  });
};